import React, {useState, useContext, useEffect} from 'react'
import {ExceedApiContext} from "../../containers/App/ExceedApi";
import {AppStoreContext} from "../Mall/AppStore/AppStore";
import {VerticalTimeline} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Activity from './Activity';
import './ActivityLog.css'

// eslint-disable-next-line import/no-anonymous-default-export
export default ({userId}) => {
    const ExceedApi = useContext(ExceedApiContext);
    const AppStore = useContext(AppStoreContext);
    const [leadComms, setLeadComms] = useState([]);

    useEffect(() => {
        const fetchActivities = async () => {
            let leadComms = await ExceedApi.getLeadAdditionalInfo(AppStore.getSelectedBot.id, userId, undefined);
            if (Array.isArray(leadComms?.conversationHistory)) {
                setLeadComms(leadComms.conversationHistory)
            }
        }
        fetchActivities();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div id={`activity_log_${userId}`} style={{overflowY: "scroll", flex: "1"}}>
        <VerticalTimeline>
            {leadComms.map(x => <Activity key={x.id} activity={x}/>)}
        </VerticalTimeline>
    </div>
}